/** Score Frenzy mutation — effect tracked via ActiveMutation timer, board unchanged */

import type { PRNG } from '../../rng.js';
import type { BoardState, MutationCard } from '../../types.js';

export function applyScoreFrenzy(
  board: BoardState,
  _card: MutationCard,
  _rng: PRNG,
): BoardState {
  // Board state is unchanged — the score doubling effect is tracked
  // via ActiveMutation timer in the engine.
  return board;
}
